import React from 'react';
import { Helmet } from 'react-helmet';
import Money from '../../../../components/Money';

/* eslint-disable react/prop-types */
const Header = ({
  shopName,
  loyaltyAmount,
  loyaltyAmountGoal,
  loyaltyTransactionsGoal,
  isAmountBased,
  customerName,
}) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center">
    <Helmet>
      <title>Loyalty Program | {shopName}</title>
    </Helmet>
    Hey {customerName}, you will receive <Money noDecimalsIfInt>{loyaltyAmount}</Money> off once you reach the goal of {
      isAmountBased ? (
        <span><Money noDecimalsIfInt>{loyaltyAmountGoal}</Money> total transaction amount</span>
      ) : (
        `${loyaltyTransactionsGoal} transactions`
      )
    }.
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerLoyaltyInitiation/components/Header.jsx